import { capitalize } from '@mui/material';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Outlet, useLocation } from 'react-router-dom';
import { LayoutProvider } from './useLayoutContext';
import SnackNotifications from "../SnackNotifications";

const handleKeyDown = (e: KeyboardEvent) => {
  if (e.key === '/') {
    e.preventDefault();
    document.getElementById('main-search-input')?.focus();
  }
};

function PageLayout() {
  const location = useLocation();

  const pageName = location.pathname
      .split('/')
      .map(s => capitalize(s.replaceAll('/', '').replaceAll('_', ' ')))
      .join(' ').trim()
    || 'Home Inspection';

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    }
  }, []);

  return (
    <LayoutProvider>
      <Helmet>
        <title>Inspectify - {pageName}</title>
        <meta
          name="description"
          content="Request Home Inspection and access Home Inspection Report"
        />
      </Helmet>
      <Outlet />
      <SnackNotifications />
    </LayoutProvider>
  );
}

export default PageLayout;
